import React from "react"
import game from "hidden.png"

const Hidden = props => <img src={game} className="game" {...props} />

export default Hidden
